import { useParams } from "react-router-dom";
import { useUserContext } from "../../_runtime/iam/session.context";
import { buildWebPathFromParams } from "../../packages/core/api-types/src/routing.utils";
import { useMemo } from "react";

export const useWebRoute = (template: string, params: Record<string,string> = {}) => {
  const urlParams = useParams();
  const userContext = useUserContext();
  const currentContextParams = {
    ...params,
    ...urlParams,
    ...userContext,
  };
  const result = buildWebPathFromParams(template, currentContextParams as any);
  return result;
}

export const useWebRouteBuilder = () => {
  const urlParams = useParams();
  const userContext = useUserContext();
  return useMemo(() => (template: string, params: Record<string,string> = {}) => {
    const currentContextParams = {
      ...urlParams,
      ...userContext,
    };
    const result = buildWebPathFromParams(template, {
      ...params,
      ...currentContextParams,

    } as any);
    return result;
  },[urlParams, userContext]);
}
